@if (slides().length) {
  <div class="tw-bg-white tw-pt-4 tw-pb-4 tw-mb-4 tw-relative">

    <div class="tw-px-4 tw-flex tw-justify-between tw-items-center tw-mb-3">
      <div>
        <p class="tw-font-lexend tw-font-bold tw-text-500 tw-leading-tight" i18n="@@skinAndHairRelated">Skin & Hair Related</p>
        <p class="tw-font-lexend tw-font-bold tw-text-500 tw-text-teal-550 tw-leading-tight" i18n="@@tipsAndVideos">Tips & Videos</p>
      </div>
      <cs-icon class="tw-shrink-0 tw-w-4 tw-text-teal-600" (click)="navigateToExplore()" [iconName]="'chevron_right_teal_rounded'"></cs-icon>
    </div>

    <div class="tw-w-full tw-relative">
      <swiper class="tw-px-4 " [config]="swiperConfig">
        @for (slide of slides(); track slide.objectId; let index = $index) {
          <div *swiperSlide
               class="tw-relative tw-rounded-2xl tw-overflow-hidden tw-flex-shrink-0"
               [style.width.px]="slide.slideWidth"
               [style.height.px]="SLIDE_HEIGHT"
               (click)="navigateToPost(slide.objectId)">
            <img [src]="slide.imageUrl"
                 alt=""
                 class="tw-w-full tw-h-full tw-object-cover tw-block" />
            @if (slide.type === appConfig.Shared.Feed.VIDEO) {
              <div class="tw-w-8 tw-aspect-square tw-rounded-full tw-z-[1] tw-bg-overlay-black tw-absolute tw-top-1/2 -tw-translate-y-1/2 tw-left-1/2 -tw-translate-x-1/2 tw-flex tw-items-center tw-justify-center">
                <svg class="tw-w-5 tw-h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                  <path fill="rgb(255, 255, 255)" d="M187.2 100.9C174.8 94.1 159.8 94.4 147.6 101.6C135.4 108.8 128 121.9 128 136L128 504C128 518.1 135.5 531.2 147.6 538.4C159.7 545.6 174.8 545.9 187.2 539.1L523.2 355.1C536 348.1 544 334.6 544 320C544 305.4 536 291.9 523.2 284.9L187.2 100.9z"/>
                </svg>
              </div>
              <div class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-black tw-opacity-20"></div>
            }
          </div>
          @if (index === slides().length - 1) {
            <div *swiperSlide class="tw-min-h-full tw-w-32 tw-mr-2 tw-rounded-2xl tw-flex tw-justify-center tw-items-center" (click)="navigateToExplore()" [style.height.px]="SLIDE_HEIGHT">
              <div class="tw-flex tw-justify-center tw-items-center tw-gap-2">
                <p class="tw-text-300 tw-text-teal-500 tw-font-bold">See All</p>
                <cs-icon class="tw-shrink-0 tw-w-4 tw-text-teal-600" [iconName]="'chevron_right_teal_rounded'"></cs-icon>
              </div>
            </div>
          }
        }
      </swiper>
    </div>
    <div class="tw-absolute tw-bottom-2 tw-right-0 tw-left-0 tw-bg-gradient-white-to-transparent-top tw-h-[60px] tw-w-full tw-z-[2] tw-pointer-events-none"></div>
  </div>
}
